import React, {Fragment, useState} from 'react';

import {PopoverBody} from 'reactstrap';

import {StyledPopoverBottomDIV} from 'app/general/bootstrap/utils';
import {FormControlGroup} from 'app/general/forms';
import {PopoverHeading} from 'app/general/overlays';
import StateButton from 'app/general/widgets/StateButton';
import {gt} from 'app/utils/i18n';

type Props = {
  title?: string;
  description?: React.ReactElement<unknown>;
  namePlaceholder?: string;
  showConfirmOnInput?: boolean;
  isCreating: boolean;
  createLabel: string;
  creatingLabel?: string;
  cancelLabel?: string;
  showCancelButton?: boolean;
  children: React.ReactNode;
  isPopover: boolean;
  small?: boolean;
  confirmDisabled?: boolean;
  defaultName?: string;
  onCancel?: () => unknown;
  onCreate: (name: string, description?: string) => void | Promise<unknown>;
};

export const GeneralCreateItem = ({
  title,
  description,
  namePlaceholder,
  showConfirmOnInput = false,
  isCreating = false,
  createLabel,
  creatingLabel = gt('Creating...'),
  cancelLabel = gt('Cancel'),
  showCancelButton = true,
  children,
  isPopover = true,
  small = false,
  confirmDisabled = false,
  onCancel,
  onCreate,
}: Props) => {
  const [nameValue, setNameValue] = useState('');

  const TitleContainer = isPopover ? PopoverHeading : 'p';
  const BodyContainer = isPopover ? PopoverBody : 'div';
  const ActionButtonsContainer = isPopover ? StyledPopoverBottomDIV : 'div';
  const smallOrPopover = isPopover || small;

  const updateName = (e: React.SyntheticEvent<HTMLInputElement>) =>
    setNameValue(e.currentTarget.value);

  const handleCreate = () => onCreate(nameValue);

  return (
    <Fragment>
      {title !== undefined ? <TitleContainer>{title}</TitleContainer> : null}

      <BodyContainer>
        {description || null}

        <div>
          <FormControlGroup field="name">
            <input
              onChange={updateName}
              value={nameValue}
              className={`form-control ${
                smallOrPopover ? 'form-control-sm' : ''
              }`}
              type="text"
              autoFocus={true}
              placeholder={namePlaceholder || ''}
            />

            {showConfirmOnInput ? (
              <span className="add-on button-container">
                <button
                  className="btn"
                  disabled={nameValue === ''}
                  onClick={handleCreate}
                >
                  {createLabel}
                </button>
              </span>
            ) : null}
          </FormControlGroup>
        </div>
        {children}
      </BodyContainer>

      {!showConfirmOnInput && (
        <ActionButtonsContainer>
          {showCancelButton ? (
            <button
              className={`btn btn-link ${smallOrPopover ? 'btn-sm' : ''}`}
              onClick={onCancel}
            >
              <i className="fa fa-times" /> {cancelLabel}
            </button>
          ) : null}

          <StateButton
            type="button"
            className={`btn-primary ${smallOrPopover ? 'btn-sm' : ''}`}
            disabled={nameValue === '' || confirmDisabled}
            busyText={creatingLabel}
            isIdle={!isCreating}
            onClick={handleCreate}
          >
            {createLabel || gt('Create')}
          </StateButton>
        </ActionButtonsContainer>
      )}
    </Fragment>
  );
};
